var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-tabs',[_c('v-tab',[_vm._v("User Admin")]),_c('v-tab-item',[_c('UserList')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }